import React, { useState } from "react";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Do you offer certified jewellery?",
      answer:
        "Yes, all our jewellery pieces come with proper certification and quality assurance."
    },
    {
      question: "What is your return policy?",
      answer:
        "We offer a 7-day easy return policy on unused products in original condition."
    },
    {
      question: "Do you provide cash on delivery?",
      answer:
        "Yes, Cash on Delivery (COD) is available for selected locations."
    },
    {
      question: "How long does shipping take?",
      answer:
        "Shipping usually takes 3–7 business days depending on your location."
    },
    {
      question: "Is your jewellery suitable for gifting?",
      answer:
        "Absolutely! Our jewellery comes in premium packaging perfect for gifting."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <div className="faq-container">
        <h2 className="faq-title">Frequently Asked Questions</h2>

        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              <span className="icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>

            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      {/* CSS SAME FILE */}
      <style>{`
        .faq-container {
          max-width: 800px;
          margin: 60px auto;
          padding: 20px;
        }

        .faq-title {
          text-align: center;
          font-size: 32px;
          margin-bottom: 40px;
          color: #000;
        }

        .faq-item {
          background: #ffffff;
          margin-bottom: 15px;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
        }

        .faq-question {
          padding: 18px 20px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px;
          background: #f9f6f2;
        }

        .faq-question:hover {
          background: #f1ece6;
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease;
          background: #fff;
        }

        .faq-item.active .faq-answer {
          max-height: 200px;
        }

        .faq-answer p {
          padding: 15px 20px;
          margin: 0;
          color: #555;
          line-height: 1.6;
        }

        .icon {
          font-size: 20px;
          color: #d4af37;
        }

        @media (max-width: 600px) {
          .faq-title {
            font-size: 24px;
          }

          .faq-question {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default Faq;
